import { useToggle } from "client/hooks/utils/useToggle";
import { capitalize } from "client/utils/capitalize";
import { translateFunc } from "client/utils/translateFunc";
import { BottomModal } from "components/common/BottomModal/BottomModal";
import { BoldIcon } from "components/common/Icons/BoldIcon";
import { CloseIcon } from "components/common/Icons/CloseIcon";
import { Translate } from "components/common/Translate/Translate";
import { TextBox } from "store/features/memeGenerator/types";
import { Option } from "../Option/Option";
import { Content } from "./Content/Content";

interface FontStyleProps {
    textBox: TextBox;
}

export const FontStyle = ({ textBox }: FontStyleProps) => {
    const { isOpen, onClose: close, open } = useToggle();
    return (
        <>
            <Option icon={<BoldIcon />} text={capitalize(translateFunc("format"))} onClick={open} />
            <BottomModal isOpen={isOpen} onClose={close} titleBar={<TitleBar onClose={close} />}>
                <Content textBox={textBox} />
            </BottomModal>
        </>
    );
};

interface TitleBarProps {
    onClose: () => void;
}

function TitleBar({ onClose }: TitleBarProps) {
    return (
        <div className="relative flex justify-center items-center py-2">
            <div className={`text-lg text-black dark:text-white`}>
                <Translate keyName="font-style" />
            </div>
            <div className={`absolute right-4 top-0 bottom-0 grid place-items-center`}>
                <div
                    className={`bg-irGray-300 dark:bg-darkSurface-200 w-6 h-6 rounded-full grid place-items-center`}
                    onClick={onClose}
                >
                    <CloseIcon />
                </div>
            </div>
        </div>
    );
}
